import { render, staticRenderFns } from "./rel-ficha-emergencia.vue?vue&type=template&id=13a08e01&"
import script from "./rel-ficha-emergencia.vue?vue&type=script&lang=js&"
export * from "./rel-ficha-emergencia.vue?vue&type=script&lang=js&"
import style0 from "./rel-ficha-emergencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports